import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose, onLoginSuccess, onLoginError, error }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="modal-header">
          <div className="app-logo">Popmates</div>
          <p>Sign in to get started</p>
        </div>
        
        <div className="modal-body">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <GoogleLogin
            onSuccess={onLoginSuccess}
            onError={onLoginError}
            theme="outline"
            size="large"
            text="signin_with"
            shape="rectangular"
            logo_alignment="left"
          />
          
          <p className="terms-text">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginModal; 